module.exports = __webpack_public_path__ + "static/media/Programme-COULON.bf13abe2.pdf";